import React,{ useEffect,useState } from 'react';
import ReactDOM from 'react-dom';

import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import "./SingleLevel.css";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
const SingleLevel = ({ item }) => {

   const [camData,setCamData] = useState("");
   // const [menuActive,setmenuActive]
   var animTime = 1;
   var cameraType = null;
   const handlecameraClick = (divname,itemtype) => {
      var menuTitle =  window.removeTags(item.title);    
      // window.RT_RecordEvent(menuTitle,  window.configProduct.name);
      window.scene._nav.SetRotationCenter([0,0,0]);      
      const leftMenu_patch = document.getElementById("leftMenu");
      leftMenu_patch.style.backgroundColor = "rgba(0, 0, 0, 0.16)";
      leftMenu_patch.style.transition = "all 2s";
      if(window.mob){
         window.scene._nav._navPanSpeed = 0.2
      }
       
   setTimeout(() => {
      window.menuHeightCalaulate();
   }, 20);
      // if(window.mob || window.isipadPortrait){
         if(document.getElementById("exterior_title") != undefined) document.getElementById("exterior_title").style.display = "none";
         if (document.getElementById("exterior_powered_logo") != undefined) document.getElementById("exterior_powered_logo").style.display = "none";
         if (document.getElementById("exterior_copilot_logo") != undefined) document.getElementById("exterior_copilot_logo").style.display = "none";
         if(document.getElementById("exterior_text_mob") != undefined) document.getElementById("exterior_text_mob").style.display = "none";
      // }

      // if (document.getElementById("recycled_elements_popup_two") != undefined) document.getElementById("recycled_elements_popup_two").style.display = "none";
      document.getElementById("right_port").classList.remove('active');
      document.getElementById("left_port").classList.add('active');
      if(document.getElementById("intel_ultra_logo") != undefined) document.getElementById("intel_ultra_logo").style.display = "none";
      // console.log(divname,itemtype)

      // if(window.mob || window.isipadPortrait){

      //    if(divname === "Render_Cam_F50_OLED_Display_02"){
      //       // alert('25')
      //       setTimeout(() => {
      //          console.log(document.getElementById('calloutbox_wrapper'));
      //          if(document.getElementById('calloutbox_wrapper')) document.getElementById('calloutbox_wrapper').style = 'display:block !important'
      //       }, 1800);
      //    }else{
      //       if(document.getElementById('calloutbox_wrapper')) document.getElementById('calloutbox_wrapper').style.display = "none"
      //    }
      // }

      // document.getElementById("exterior_text_mob").style.display = "none";
      window.hideAllPopup();
      let currentActivePopup = document.querySelector('.content.currentActivePopup');
      let currentActiveHotspot = document.querySelector('.hotspots.currentActiveHotspot');
      if(currentActiveHotspot != null) currentActiveHotspot.classList.remove('currentActiveHotspot');
      if(currentActivePopup != null) currentActivePopup.classList.remove('currentActivePopup');
      let currentActivesinglePopup  = document.querySelector('.singlePopup.active');
      if(currentActivesinglePopup != null) currentActivesinglePopup.classList.remove('active');

      let hotspotsActive = [...document.querySelectorAll(".hotspots")];
      hotspotsActive.forEach(ele => {
            ele.style.display = "none";
      });
      window.currentPosition = '';

      window.scene._fDoFFarAperture = 0;
      window.scene._fDoFNearAperture = 0
      // if (window.mob) {
      //    window.scene._bDoF = false;
      // } else {
      //    window.scene._bDoF = false;
      // }
     
      if (itemtype !== 'Skins') {
         if (window.functionClick) return false;
         window.functionClick = true;   
         if (!divname) {
            return false;
         }
         if (window.menuClick == false) {
            return false;
         }
         var isActive = document.getElementById(divname)
         if (isActive.classList.contains('active')) {
            if (window.mob || (window.isipad && window.innerHeight > window.innerWidth)) {
               document.getElementById(divname).classList.remove('active');
            }
         }
         else {
            const collection = document.getElementsByClassName("menu");
            for (let i = 0; i < collection.length; i++) {
               collection[i].classList.remove('active');
            }
            document.getElementById(divname).classList.add('active');
         }

         if (window.mob || window.isipad || window.innerWidth < 818 || window.innerHeight < 818) {
            const arrow = document.getElementsByClassName("content1");
            for (let i = 0; i < arrow.length; i++) {
               if (arrow[i].getAttribute('id') !== "content1-" + divname + "") {
                  arrow[i].style.maxHeight = null
               }
            }
            var content = document.getElementById("content1-" + divname + "");
            if (content.style.maxHeight) {
               content.style.maxHeight = null;
            } else {
               content.style.maxHeight = content.scrollHeight + "px";
            }

         }
         //console.log((divname)

         if (divname === "Render_Cam_Premium_Suite_Keyboard_F50") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Premium_Suite_Keyboard_F50) }
            else { window.Render_Cam_Premium_Suite_Keyboard_F50() }
            window.selectedMenu.active = 'Render_Cam_Premium_Suite_Keyboard_F50';
         }

         else if (divname === "Render_Cam_Ports_F50") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Ports_F50) }
            else { window.Render_Cam_Ports_F50() }
            window.selectedMenu.active = 'Render_Cam_Ports_F50';
         }

         else if (divname === "Render_Cam_3Q_Front_Left_Open_F50") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_3Q_Front_Left_Open_F50) }
            else { window.Render_Cam_3Q_Front_Left_Open_F50() }
            window.selectedMenu.active = 'Render_Cam_3Q_Front_Left_Open_F50';
         }

         else if (divname === "Render_Cam_Premium_Suite_Camera_F50") {
            cameraType = 'exterior';            
            if (window.selectedMenu.cameraType != cameraType) { 
               window.fadeIn(window.Render_Cam_Premium_Suite_Camera_F50) }
            else {
                window.Render_Cam_Premium_Suite_Camera_F50() 
               }
            window.selectedMenu.active = 'Render_Cam_Premium_Suite_Camera_F50';
         }

         else if (divname === "Reset_View_F14") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Reset_View_F14) }
            else { window.Reset_View_F14() }
            window.selectedMenu.active = 'Reset_View_F14';
         }

         else if (divname === "Ultra_Connectivity_01_F13") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Ultra_Connectivity_01_F13) }
            else { window.Ultra_Connectivity_01_F13() }
            window.selectedMenu.active = 'Ultra_Connectivity_01_F13';
         }

         else if (divname === "Render_Cam_F50_OLED_Display_02") {
            cameraType = 'exterior';
            window.scene._bDoF = false;
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_F50_OLED_Display_02) }
            else { window.Render_Cam_F50_OLED_Display_02() }
            window.selectedMenu.active = 'Render_Cam_F50_OLED_Display_02';
         }

         else if (divname === "Render_Cam_CPU_01_F140") {
            cameraType = 'interiorflip';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_CPU_01_F140) }
            else { window.Render_Cam_CPU_01_F140() }
            window.selectedMenu.active = 'Render_Cam_CPU_01_F140';
         }

         else if (divname === "Render_Cam_F60_Processor") {
            cameraType = 'interior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_F60_Processor) }
            else { window.Render_Cam_F60_Processor() }
            window.selectedMenu.active = 'Render_Cam_F60_Processor';
         }

         else if (divname === "Render_Cam_AI_F160") {
            cameraType = 'interiorAICore';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_AI_F160) }
            else { window.Render_Cam_AI_F160() }
            // window.fadeIn(window.Render_Cam_F110_Intel_Chip_New)
            window.selectedMenu.active = 'Render_Cam_AI_F160';
         }
         else if (divname === "Render_Cam_2_Speaker_Explode_F50") {
            cameraType = 'interiorGPU';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_2_Speaker_Explode_F50) }
            else { window.Render_Cam_2_Speaker_Explode_F50() }
            window.selectedMenu.active = 'Render_Cam_2_Speaker_Explode_F50';
         }
         // else if (divname === "Render_Cam_Speaker_Explode_F150") {
         //    cameraType = 'interiorBottomSpeaker';
         //    if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Speaker_Explode_F150) }
         //    else { window.Render_Cam_Speaker_Explode_F150() }
         //    // window.fadeIn(window.Render_Cam_F110_Intel_Chip_New)
         //    window.selectedMenu.active = 'Render_Cam_Speaker_Explode_F150';
         // }

         else if (divname === "Render_Cam_Display_F50") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Display_F50) }
            else { window.Render_Cam_Display_F50() }
            window.selectedMenu.active = 'Render_Cam_Display_F50';
         }

         else if (divname === "Render_Cam_F60_Exhaust_Fins") {
            cameraType = 'interior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_F60_Exhaust_Fins) }
            else { window.Render_Cam_F60_Exhaust_Fins() }
            window.selectedMenu.active = 'Render_Cam_F60_Exhaust_Fins';
         }

         else if (divname === "Render_Cam_F110_GPU") {
            cameraType = 'interior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_F110_GPU) }
            else { window.Render_Cam_F110_GPU() }
            window.selectedMenu.active = 'Render_Cam_F110_GPU';
         }
         else if (divname === "superior_sound") {
            cameraType = 'interiorflip';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.superior_sound) }
            else { window.superior_sound() }
            window.selectedMenu.active = 'superior_sound';
         }
         else if (divname === "Render_Cam_3Q_Front_Right_Open_F50") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_3Q_Front_Right_Open_F50) }
            else { window.Render_Cam_3Q_Front_Right_Open_F50() }
            window.selectedMenu.active = 'Render_Cam_3Q_Front_Right_Open_F50';
         }
         else if (divname === "Render_Cam_Recall_F41") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Recall_F41) }
            else { window.Render_Cam_Recall_F41() }
            window.selectedMenu.active = 'Render_Cam_Recall_F41';
         }
         else if (divname === "Render_Cam_Ports_F50_Right") {
            cameraType = 'exterior';
            if (window.selectedMenu.cameraType != cameraType) { window.fadeIn(window.Render_Cam_Ports_F50_Right) }
            else { window.Render_Cam_Ports_F50_Right() }
            window.selectedMenu.active = 'Render_Cam_Ports_F50_Right';
         }

         // console.log(item.cameraName, "camera")
         GotoPosInTimeNamedValue(item.cameraName,function () {
            window.selectedMenu.cameraType = cameraType;
            window.fadeOut();
            if(window.selectedMenu.active == "Render_Cam_CPU_01_F140"){
            window.scene._nav.SetRotationCenter([6.090139827999998, 6.961955584535348, -6.589301438574051]);
            } else if(window.selectedMenu.active == "Render_Cam_AI_F160"){
               window.scene._nav.SetRotationCenter([0.928139827999998, 12.922161808745157, -5.200212987816656]);  
            }else{
               window.scene._nav.SetRotationCenter([0,0,0]);
            }

            // if(window.selectedMenu.active == "Render_Cam_CPU_01_F140"){
            //    if (document.getElementById("recycled_elements_popup_two") != undefined) document.getElementById("recycled_elements_popup_two").style.display = "block";
            // }
            
         });
      } else {
         const collection = document.getElementsByClassName("skin_menu");
         document.getElementById("Skins").classList.remove('MuiCollapse-hidden');
         document.getElementById("Skins").classList.add('MuiCollapse-entered');
         document.getElementById("Interior").classList.remove('MuiCollapse-entered');
         document.getElementById("Interior").previousSibling.classList.remove('menuActive');
         document.getElementById("Exterior").classList.remove('MuiCollapse-entered');
         document.getElementById("Exterior").previousSibling.classList.remove('menuActive');
         document.getElementById("Skins").previousSibling.classList.add('menuActive');
         for (let i = 0; i < collection.length; i++) {
            collection[i].classList.remove('active');
         }
         window.changeSkin(divname);
      }
      window.fRotMinLimitVal = 0.02;
      window.updateNavigation(divname);
      window.resetpop();
      setTimeout(function(){
         window.updateZoomSliderUIOnly(window.sliderEl3, window.scene._nav.getZoomFactor());
      },2200);
      window.calloutPositionReset();

   }
   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname, onComplete, onSample) => {
      let zoomResize = window.setZoomReset();
      var opt = undefined;
      if (!(window.mob || window.isipadPortrait)) {
         var gp = camData[gotoposname];
      } else {
         if (gotoposname == 'Render_Cam_Thin_Light_F100' || gotoposname == 'Render_Cam_Recall_F41') {
            var gp = camData[gotoposname + '_mob'];
            }else{
               var gp = camData[gotoposname];  
         // var gp = camData[gotoposname + '_mob'];
            }
         if (gotoposname == 'Render_Cam_Display_F50') { 
            zoomResize = 15;
         }
         else {
            zoomResize = 0;
         }
      }
      if (gp.fovy && window.scene.fovy !== gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt)
            opt = {};
         opt.zang = gp.pos[5];
      }
      gp.time = animTime;
      // console.log(zoomResize)
      window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4] + zoomResize, 2000, onComplete, slowinout2, opt);
   }
   
   function slowinout2(x) {
      var a = 4.0;
      var x2 = 1.0 - x;
      var px = Math.pow(x,a);
      var px2 = Math.pow(x2,a);
      return px / (px + px2);
   }
   const GetData = async () => {

      await fetch('model_gl/config.json'
         ,{
            headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json'
            }
         }
      ).then((response) => response.json())
         .then((myJson) => {
            setCamData(myJson.positions);
         })         
   }
   useEffect(() => {
      GetData();
   },[]);

   return (
      item.type !== 'Skins' ? <div className={`menu`} id={item.id}>
         <ListItem button className='collapsible' onClick={() => { handlecameraClick(item.id,item.type) }}>
            <div className='accordia_icon'>
               <img className='arrow' src='img/spacer.png' id={`accordianIcon_${item.id}`} />
            </div>
            {/* <ListItemText primary={item.title} /> */}
            {
               <div className="MuiListItemText-root"><span className="MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock">{ ReactHtmlParser(item.title) }</span></div>
            }
         </ListItem>
         {ReactDOM.createPortal(
         <>
            {item.content && item.content.map((child, key) => (
                  <div key={key} className='calloutbox font28 calloutbox_white' data-id={child.dataId} id={child.dataId+'_popupJSON'}>
                     <h3>
                        {/* {child.heading} */}
                        { ReactHtmlParser(child.heading) }
                     </h3>
                     <div className='content'>
                        <div>
                           <ul>
                                 <li className='calloutText1'>
                                 {/* {child.text} */}
                                 { ReactHtmlParser(child.text) }
                                 </li>
                                 {child.content2  && <ul>
                                    {child.content2 && child.content2.map((content2, key) => {
                                       return (
                                          <li  key={key} className='submenutext'>{content2}</li>
                                       )
                                    })
                                    }
                                 </ul> }

                              </ul>
                          
                        {child.text2 !== undefined &&
                        <ul>
                           <li className='calloutText2'>
                              {/* {child.text2} */}
                              { ReactHtmlParser(child.text2) }
                           </li>
                        </ul>
                        } 
                        </div>
                        {child.text3 !== undefined &&
                           <ul>
                              <li>
                                 {/* {child.text3} */}
                                 { ReactHtmlParser(child.text3) }
                              </li>
                           </ul>
                        }
                         {child.text4 !== undefined &&
                           <ul>
                              <li>
                                 {/* {child.text3} */}
                                 { ReactHtmlParser(child.text4) }
                              </li>
                           </ul>
                        }
                         {child.text5 !== undefined &&
                           <ul>
                              <li>
                                 {/* {child.text3} */}
                                 { ReactHtmlParser(child.text5) }
                              </li>
                           </ul>
                        }
                         {child.text6 !== undefined &&
                           <ul>
                              <li>
                                 {/* {child.text3} */}
                                 { ReactHtmlParser(child.text6) }
                              </li>
                           </ul>
                        }
                        {child.vproicon !== undefined &&
                           <img className={`vpro_logo`} src={child.vproicon} />
                        }
                         {child.intelicon !== undefined &&
                           <img className={`intel_logo`} src={child.intelicon} />
                        }
                         {child.intelcoreicon !== undefined &&
                           <img className={`intel_core_logo`} src={child.intelcoreicon} />
                        }
                         {child.intelcoreiconwith7 !== undefined &&
                           <img className={`intel_core_logo`} src={child.intelcoreiconwith7} />
                        }
                         {(child.bottomBtn1 != undefined && child.bottomBtn2) && <div id="penButtondiv">
                           <div id={child.bottomBtn1.id} className={child.bottomBtn1.classList}>{child.bottomBtn1.text} </div>
                           <div id={child.bottomBtn2.id} className={child.bottomBtn2.classList}>{child.bottomBtn2.text} </div>
                        </div>
                        }
                         {(child.topBtn1 != undefined && child.topBtn2) && <div id="soundButtondiv">
                           <div id={child.topBtn1.id} className={child.topBtn1.classList}>{child.topBtn1.text} </div>
                           <div id={child.topBtn2.id} className={child.topBtn2.classList}>{child.topBtn2.text} </div>
                        </div>
                        }
                     </div>
                  </div>
               ))
               }
         </>, document.getElementById('calloutContainer')
         )}
         <div className="content1" id={`content1-${item.id}`}>
            <div id={`hotspot_${item.id}`}>

               {item.content && item.content.map((child,key) => (
                  <div key={key} className='popuptogglebtn' data-id={child.dataId}>
                     <p>
                        {/* {child.heading} */}
                        { ReactHtmlParser(child.heading) }
                     </p>
                     <h5 className='calloutText1'>
                        {/* {child.text} */}
                        { ReactHtmlParser(child.text) }
                        <ul>
                           {child.content2 && child.content2.map((content2, key) => {
                              return (
                                 <li key={key} className='submenutext'>{content2}</li>
                              )
                           })
                           }
                        </ul>

                     </h5>
                     { child.text2 !== undefined && 
                        <h5 className='calloutText2'>
                        {/* {child.text2} */}
                        { ReactHtmlParser(child.text2) }
                        </h5>
                     }  
                     { child.text3 !== undefined && 
                        <h5 className='calloutText3'>
                        {/* {child.text3} */}
                        { ReactHtmlParser(child.text3) }
                        </h5>
                     } 
                     { child.text4 !== undefined && 
                        <h5 className='calloutText4'>
                        {/* {child.text4} */}
                        { ReactHtmlParser(child.text4) }
                        </h5>
                     }  
                      { child.text5 !== undefined && 
                        <h5>
                        {/* {child.text4} */}
                        { ReactHtmlParser(child.text5) }
                        </h5>
                     }  
                      { child.text6 !== undefined && 
                        <h5>
                        {/* {child.text4} */}
                        { ReactHtmlParser(child.text6) }
                        </h5>
                     }  
                     {child.vproicon !== undefined && 
                     <img className={`vpro_logo_mob`} src={child.vproicon} />
                     }      
                     {child.intelicon !== undefined &&
                       <img className={`intel_logo_mob`} src={child.intelicon} />
                    }
                      {child.intelcoreicon !== undefined &&
                        <img className={`intel_core_logo_mob`} src={child.intelcoreicon} />
                     }     
                         {child.intelcoreiconwith7 !== undefined &&
                        <img className={`intel_core_logo_mob`} src={child.intelcoreiconwith7} />
                     }   
                       {(window.mob || window.isipad && window.innerHeight > window.innerWidth) && item.content && item.id == 'Render_Cam_Ports_F50' ? <div id="penButtondiv">
                  <div id="left_port" className="active">Left Port </div>
                  <div id="right_port" className="">Right Port </div>
               </div>
                  : ''}   
                  {(window.mob || window.isipad && window.innerHeight > window.innerWidth) && item.content && item.id == 'Render_Cam_2_Speaker_Explode_F50' ? <div id="soundButtondiv">
                  <div id="top_speaker_button" className="active">Top </div>
                  <div id="bottom_speaker_button" className="">Bottom </div>
               </div>
                  : ''}  
                  </div>
               ))
               }
              
            </div>
         </div>
      </div>
         : <div className={`skin_menu`} id={item.id}>
            <ListItem button onClick={() => { handlecameraClick(item.id,item.type) }} title={item.name}>
               <div className='skin_icon'>
                  <img className='' src={item.icon} />
               </div>
            </ListItem>
         </div>
   );
};
export default SingleLevel